import {createReducer, on} from '@ngrx/store';
import {ClearState} from "./participant-groups-list.actions";

// State for this feature (User)
export interface ParticipantGroupsListState {
  dummy: string
}

const initialState: ParticipantGroupsListState = {
  dummy: ''
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, (state) => initialState),
);
